import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home.vue'
import Redirect from '../components/Redirect.vue'
import TemplateForm from '../components/TemplateForm.vue'
import MedicalCare from '../components/MedicalCare.vue'
import OpticalCare from '../components/OpticalCare.vue'
import DentalCare from '../components/DentalCare.vue'
import Hospitalization from '../components/Hospitalization.vue'
import Services from '../helpers/common.services'
import Branding from '../helpers/branding'
import { simulationTypes } from '../helpers/types'

const redirectLocation = '/disconnected'
const rootPath = '/'
const medicalCarePath = '/medicalcare'
const dentalCarePath = '/dentalcare'
const opticalCarePath = '/opticalcare'
const hopitalizationPath = '/hospitalization'
Vue.use(Router)

var brand = Branding.getBrandTitle()
var router = new Router({
  mode: 'history',
  routes: [
    {
        path: rootPath,
        components:{
            main:Home,
            specific:null
        },
        meta: { title: brand + 'Simulateur - Accueil' },
    },
    {
        path: medicalCarePath, 
        components: {
            main:TemplateForm,
            specific:MedicalCare
        },
        meta: { title: brand + 'Simulateur - Consultation' }
    },
    {
        path: dentalCarePath,
        components: {
            main:TemplateForm,
            specific:DentalCare
        },
        meta: { title: brand + 'Simulateur - Dentaire' }
    },
    {
        path: opticalCarePath, 
        components: {
            main:TemplateForm,
            specific:OpticalCare
        },
        meta: { title: brand + 'Simulateur - Optique' }
    },
    {
        path: hopitalizationPath, 
        components: {
            main:TemplateForm,
            specific:Hospitalization
        },
        meta: { title: brand + 'Simulateur - Hospitalisation' }
    },
    {
        path: '*', 
        components: {
            main:Redirect,
            specific:null
        },
        meta: { title: brand + 'Déconnecté' }
    }
  ]
})

const redirectWhenNotLoggued = function() {
    router.push(redirectLocation)
}

router.getPathTitle = function(path) {
    if (path == medicalCarePath)
        return simulationTypes.medicalCare.value
    if (path == opticalCarePath)
        return simulationTypes.opticalCare.value
    if (path == dentalCarePath)
        return simulationTypes.dentalCare.value
    if (path == hopitalizationPath)
        return simulationTypes.hospitalization.value
}

router.beforeEach((to, from, next) => {
    var registeredToken = localStorage.getItem('user-token')
    var authRequired = to.fullPath != redirectLocation
    
    if(window.location.host.includes(process.env.SIMULATOR_URL_CPM))
        Branding.setBrand(Branding.CPM)
    if(window.location.host.includes(process.env.SIMULATOR_URL_MGD))
        Branding.setBrand(Branding.MGD)
    if(window.location.host.includes(process.env.SIMULATOR_URL_ACS))
        Branding.setBrand(Branding.ACS)
    if (window.location.host.includes(process.env.SIMULATOR_URL_GSA))
        Branding.setBrand(Branding.GSA)

    if (Branding.isValid(to.query.cab)) {
        Branding.setBrand(to.query.cab)
    } else {
        console.log("Brand not recognized, please make sure you are using lower-case letters")
    }

    if (to.query.media) {
        Branding.setDevice(to.query.media)
    }

    // if authentication required (=when page is not /error)
    if (authRequired)
    {
        // Token is being passed on to simulator
        if (to.query.token != null)
        {
            Services.GetTokenApproval(to.query.token)
            .then(response => {
                if(response.data.auth == true || response.data.auth == 'true' ) {
                    localStorage.setItem('user-token', to.query.token)
                }
                else {
                    localStorage.removeItem('user-token')
                    redirectWhenNotLoggued()
                }
            })
            .catch(error => {
                console.log(error)
                redirectWhenNotLoggued()
            })
        }
        // Token is not registered
        else if (registeredToken == '' || registeredToken == null) {
            redirectWhenNotLoggued()
        } else {
            Services.GetTokenApproval(registeredToken)
            .then(response => {
                if(response.data.auth != true && response.data.auth != 'true' ) {
                    localStorage.removeItem('user-token')
                    redirectWhenNotLoggued()
                }
            })
            .catch(error => {
                console.log(error)
                redirectWhenNotLoggued()
            })
        }
    }
    next()
});

router.afterEach((to, from) => {
    document.title = to.meta.title || 'CPMS - Simulateur de remboursement';
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js